import React from 'react'

export default function Hero() {
    return (
        <div className="content hero">
            <h1>JA Creation</h1>
            <p>Satisfy Your Website Needs From Us</p>
            
        </div>
    )
}
